import '../index.scss';

import { LuiButton, LuiIcon } from '@linzjs/lui';
import { LuiIconName } from '@linzjs/lui/dist/assets/svg-content';
import { PropsWithChildren, ReactElement, useContext, useLayoutEffect, useState } from 'react';

import { PanelHeaderButton } from '../panel';
import { LuiModalAsyncInstanceContext } from './LuiModalAsyncInstanceContext';

export interface LuiModalAsyncHeaderProps {
  icon?: LuiIconName | ReactElement | null;
  title: string;
  closeButton?: true;
  helpLink?: string;
  onHelpClick?: () => void;
  // @Deprecated This has no effect.  Don't use it
  helpButtonLevel?: 'text' | 'plain-text' | 'primary' | 'secondary' | 'tertiary' | 'success' | 'error';
}

/**
 * Generic modal header.
 */
export const LuiModalAsyncHeader = ({
  icon,
  title,
  closeButton,
  helpLink,
  onHelpClick,
  helpButtonLevel,
}: PropsWithChildren<LuiModalAsyncHeaderProps>) => {
  const { ownerRef, close } = useContext(LuiModalAsyncInstanceContext);
  const [disabled, setDisabled] = useState(true);

  // Dialogs autofocus buttons even when flagged not to
  // On initial display the header buttons are disable to prevent this
  useLayoutEffect(() => {
    // oxlint-disable-next-line react/set-state-in-effect
    setDisabled(false);
  }, []);

  return (
    <div className={'LuiModalAsync-header'}>
      {icon &&
        (typeof icon === 'string' ? (
          <LuiIcon
            name={icon}
            alt={'icon'}
            size={'md'}
            className={`LuiModalAsync-header-icon LuiModalAsync-header-icon-${icon}`}
          />
        ) : (
          icon
        ))}
      <h4>{title}</h4>
      {(helpLink || onHelpClick) && (
        <LuiButton
          type={'button'}
          level={helpButtonLevel || 'plain-text'}
          aria-label={'Help'}
          title={'Help'}
          className={'lui-button-icon-only'}
          disabled={disabled}
          buttonProps={{ 'data-noautofocus': true, tabIndex: -1 }}
          onClick={
            helpLink
              ? () => (ownerRef.current?.ownerDocument?.defaultView ?? window).open(helpLink, '_blank')
              : onHelpClick
          }
        >
          <LuiIcon name="ic_help_outline" alt="Help" size="md" className={'LuiModalAsync-help-icon'} />
        </LuiButton>
      )}
      {closeButton && <PanelHeaderButton aria-label={'Close'} onClick={close} icon={'ic_clear'} />}
    </div>
  );
};
